
export const parseStringTipoEstructura = (tipoEstructura) => {
    return tipoEstructura.toLowerCase().replace(/\s+/g, '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9_]/g, '');    
}

export const diccionarioTipoEstructuraCrearProyectoSufijoMSJServidor = (tipoEstructura) => {
    let stringPrfix = '';

    switch (tipoEstructura) {
        case 'unidad_activa':
            stringPrfix = 'catedra_activa';
            break;
        case 'aprendizaje_basado_en_proyectos':
        default:
            stringPrfix = '';
            break;
    }

    const prefix = `crear_proyecto${stringPrfix ? '_' + stringPrfix : ''}`;

    return prefix;
}


//'Aprendizaje basado en proyectos'
//'Unidad Activa'